import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ApplicationConfig} from '@angular/core';
import {provideRouter, Routes, withNavigationErrorHandler} from '@angular/router';
import {provideEnvironmentNgxMask} from 'ngx-mask';
import {AngebotComponent} from './angebot/angebot.component';
import {AusschreibungComponent} from './ausschreibung/ausschreibung.component';
import {HomeComponent} from './home/home.component';
import {HttpErrorInterceptor} from './interceptor/http.interceptor';
import {KontaktComponent} from './kontakt/kontakt.component';
import {LandingComponent} from './landing/landing.component';
import {AusschreibungResolver} from './resolver/ausschreibung.resolver';
import {AusschreibungService} from './service/ausschreibung.service';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    }, {
        path: 'ausschreibung/:id',
        component: AusschreibungComponent,
        resolve: {ausschreibung: AusschreibungResolver}
    }, {
        path: 'angebot/:id',
        component: AngebotComponent,
        resolve: {ausschreibung: AusschreibungResolver}
    },
    {path: 'landing', component: LandingComponent},
    {path: 'ng', redirectTo: 'ausschreibung/undefined'},
    {path: 'kontakt', component: KontaktComponent}
];

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes, withNavigationErrorHandler((error: any) => {
            console.error('Router navigation error' + error);
        })),

        provideHttpClient(withInterceptorsFromDi()),
        provideEnvironmentNgxMask(),
        AusschreibungService, {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        }
    ]
}
